<template>
    <div class="media">
        <img :src="getUrl(person.photo.id, 900)" />
    </div>
</template>

<script>
import getters from "@/mixins/getters.mixin";

export default {
    mixins: [getters],
    props: {
        person: {
            type: Object,
            required: true,
        },
    },
};
</script>

<style lang="sass" scoped>
@import ~include-media/dist/include-media
@import ~styles/base
@import ~styles/typography

.media
    position: relative
    z-index: 1

    +media('>=large')
        flex: 0 0 50%

    img
        display: block
        width: 60%
        box-shadow: 1em 1em 1.5em transparentize(black, .9)

        +media('<large')
            margin-right: auto
            margin-left: auto

        +media('>=large')
            width: 50%


+media('>=large')
    .member
        &:nth-child(odd)
            .media
                transform: translateX(15.5%)
            img
                margin-left: auto

        &:nth-child(even)
            .media
                transform: translateX(-15.5%)
</style>
